
import mount_component from './mount';
import * as components from './components/**/*.jsx';

//Mount
const { default: componentsArray, filenames } = components;
mount_component(componentsArray.map(x=>x.default), filenames);